<ds-item-search-result-list-element
  [showThumbnail]="showThumbnail"
  [showLabel]="showLabel"
  [object]="{ indexableObject: object, hitHighlights: {} }"
  [linkType]="linkType"
></ds-item-search-result-list-element>
